import OwnerLayout from "@/components/owner/OwnerLayout";
import RefundManager from "@/components/booking/RefundManager";

export default function OwnerRefundsPage() {
  return (
    <OwnerLayout testid="owner-refunds-shell">
      <RefundManager role="owner" testidPrefix="owner-refunds" />
    </OwnerLayout>
  );
}
